import { array } from 'fp-ts';
import { lt } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { SubContentSection } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { WithCancellationPolicies } from '../../../../../../rateGroups/types';
import { CancellationPolicyName } from '../../../../../../../components';

export const CancellationPoliciesSection = ({ cancellationPolicies }: Partial<WithCancellationPolicies>) => (
    <SubContentSection title={lt('Cancellation')} contentSpacing="0">
        {cancellationPolicies && array.isNonEmpty(cancellationPolicies) ? (
            <Stack vertical>
                {cancellationPolicies.map((cancellationPolicy) => (
                    <CancellationPolicyName
                        {...cancellationPolicy}
                        format="nameAndParameters"
                        key={cancellationPolicy.id}
                    />
                ))}
            </Stack>
        ) : (
            UnicodeEntity.Dash
        )}
    </SubContentSection>
);
